<div *ngIf="!validatePaymentGreaterThanBalance">
  <div class="width" *ngIf="!refundView">
    <div class="row d-flex justify-content-center content-wrapper">
      <div class="col-12 col-md-5 gray-box">
        <h5>PLAN ACTUAL</h5>
        <p>{{this.currentPlan}}</p>
        <div class="col-12 d-flex justify-content-center align-items-center flex-column">
          <p>PRECIO</p>
          <h3>{{this.actualPrice | currency}}</h3>
        </div>
      </div>
      <div class="col-12 col-md-5 offset-md-1 white-box">
        <h5>PLAN SELECCIONADO</h5>
        {{this.planToChange}} :
        <span *ngFor="let description of this.descriptions; let n = index">
        {{description.description}}
      </span>
        <div class="col-12 d-flex justify-content-center align-items-center flex-column">
          <p>PRECIO</p>
          <h3 class=" roboto-b f-red">{{this.pricePlan | currency}}</h3>
        </div>
      </div>
      <div class="container">
        <div class="logline full my-5"></div>
      </div>
      <div class="basicrow text-center m-top pb-3">
        <a class="btns def-i red pull-right vcenter derecha" (click)="this.applyChange()">
            <span class="tabcell">
              Cambiar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
        </a>
        <a (click)="this.backPage()" class="btns def-i gray pull-left vcenter izquierda">
            <span class="tabcell">
              <i class="fa fa-angle-left" aria-hidden="true"></i>&nbsp;&nbsp;Regresar
            </span>
        </a>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center" *ngIf="refundView">
    <div class="text-center">
      <h2 class="title-recharge">Aviso <img src="../../../../assets/images/claro-lines.png" class="img" alt=""></h2>
      <p>Estimado cliente al momento estamos presentando problemas para activacion de su nuevo plan.</p>
      <p class="m-0"><b>El balance de su recarga y los cargos asociados a su pago se encuentran en proceso de devolucion.</b></p>
      <p class="mb-4">Por favor verifique en las proximas horas.</p>
      <div class="d-flex justify-content-center mb-5">
        <button class="button-ok" (click)="return()">
          Ok
        </button>
      </div>
    </div>
  </div>
</div>
<!--    <div class="row mb-5 d-flex justify-content-center align-items-center gray-panel">-->
<!--      <div class="col text-center border-right py-3">-->
<!--        <span class="roboto-b">Número de Teléfono</span><br/>-->
<!--        <span class="f-big roboto-b">{{this.subscriber}}</span>-->
<!--      </div>-->
<!--      <div class="col text-center border-left py-3">-->
<!--        <span class="roboto-b">Balance en Prepago Disponible</span><br/>-->
<!--        <span class="f-lsemi roboto-b f-red">{{this.currentBalance | currency}}</span></div>-->
<!--    </div>-->
<!--    <div class="row d-flex justify-content-center">-->
<!--      <div class="row">-->
<!--        <div class="col">-->
<!--          <div class="d-flex align-items-center alert-snackbar justify-content-center mb-5">-->
<!--            <mat-icon>info</mat-icon>-->
<!--            <p class="m-0">El plan seleccionado tiene un costo mayor a su balance disponible, por favor realice el pago-->
<!--              de <b>{{ balanceToRecharge }}</b> para procesar su solicitud de cambio de plan. </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="row mb-5 pb-5">-->
<!--        <div class="col">-->
<!--          <div class=" roboto-b f-bmed text-center mb-3">-->
<!--            Monto seg&uacute;n Plan Seleccionado-->
<!--          </div>-->
<!--          <div class="d-flex justify-content-center">-->
<!--            <button [ngClass]="{'amount-to-recharge-active': this.checked === true, 'amount-to-recharge-disabled': this.checked === false}" (click)="this.checked = !this.checked">-->
<!--              <mat-icon class="mr-2" *ngIf="checked">check_box</mat-icon>-->
<!--              <mat-icon class="mr-2" *ngIf="!checked">check_box_outline_blank</mat-icon>-->
<!--              <p class="m-0">-->
<!--                {{balanceToRecharge|currency}}-->
<!--              </p>-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="row">-->
<!--      <div class="col">-->
<!--        <div class="text-center m-top pb-3" ng-if="this.list.length > 0">-->
<!--          <button class="btns def-i pull-right vcenter derecha" (click)="rechargeDiff()" [ngClass]="{'red': checked === true, 'gray': checked === false}" [disabled]="!checked">-->
<!--            <span class="tabcell pl-4">-->
<!--              Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>-->
<!--            </span>-->
<!--          </button>-->
<!--          <a (click)="this.backPage()" class="btns def-i gray pull-left vcenter izquierda">-->
<!--            <span class="tabcell">-->
<!--              <i class="fa fa-angle-left" aria-hidden="true"></i>&nbsp;&nbsp;Regresar-->
<!--            </span>-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->


<!--</div>-->



<!--<div class="basicrow tabtopb f-black roboto-r f-reg" *ngIf="!validatePaymentGreaterThanBalance">-->
<!--  <div class="basicrow">-->
<!--    <div class="row">-->
<!--      <div class="actual-plan-box col col-md-6">-->
<!--        <div class="userinfo full nomtops">-->
<!--          <div class="basicrow m-bott">-->
<!--            <div class="basicrow f-bmed roboto-b m-bott">-->
<!--              PLAN ACTUAL:-->
<!--            </div>-->
<!--            <div class="redstat">-->
<!--              <div class="basicrow" style="line-height: 1.5; text-align: justify;">-->
<!--                {{this.currentPlan}}<br>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="basicrow text-center m-top-ii">-->
<!--            <div class="basicrow">-->
<!--                            <span class="roboto-b">-->
<!--                              PRECIO-->
<!--                            </span><br>-->
<!--              <span class="f-gray f-semi roboto-m">-->
<!--                              {{this.actualPrice | currency}}-->
<!--                            </span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="selected-plan-box h-mtop col col-md-6 plan-seleccionado">-->
<!--        <div class="userinfo trnsinfo full nomtops plan-selected">-->
<!--          <div class="basicrow m-bott">-->
<!--            <div class="basicrow f-bmed roboto-b m-bott">-->
<!--              PLAN SELECCIONADO:-->
<!--            </div>-->
<!--            <div class="redstat">-->
<!--              <div class="basicrow" style="line-height: 1.5; text-align: justify;">-->
<!--                {{this.planToChange}} :-->
<!--                <span *ngFor="let description of this.descriptions; let n = index">-->
<!--                                  {{description.description}}-->
<!--                                </span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="basicrow text-center m-top-ii">-->
<!--            <div class="basicrow borde-precio">-->
<!--                            <span class="roboto-b">-->
<!--                              PRECIO-->
<!--                            </span><br>-->
<!--              <span class="f-red f-semi roboto-m">-->
<!--                              {{this.pricePlan|currency}}-->
<!--                            </span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div *ngIf="!validatePaymentGreaterThanBalance">-->
<!--    <div class="basicrow m-top-i py-4">-->
<!--      <div class="logline full"></div>-->
<!--    </div>-->
<!--    <div class="basicrow text-center m-top pb-3">-->
<!--      <a class="btns def-i red pull-right vcenter derecha" (click)="this.applyChange()">-->
<!--            <span class="tabcell">-->
<!--              Cambiar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>-->
<!--            </span>-->
<!--      </a>-->
<!--      <a (click)="this.backPage()" class="btns def-i gray pull-left vcenter izquierda">-->
<!--            <span class="tabcell">-->
<!--              <i class="fa fa-angle-left" aria-hidden="true"></i>&nbsp;&nbsp;Regresar-->
<!--            </span>-->
<!--      </a>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
